import React, { useState } from "react";
import ModalView from "@modals/modalview/ModalView";
import phoneIcon from "@assets/icons/phone-icon.svg";
import lockIcon from "@assets/icons/password-lock.svg";
import styles from "./LoginWithPassword.module.css";
import {
  readStoredPhoneCredentials,
  usePasswordLogin,
  useLoginModals,
} from "@hooks/login";

interface PasswordLoginProps {
  isOpen: boolean;
  onClose: () => void;
}

function LoginWithPassword({ isOpen, onClose }: PasswordLoginProps) {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const { goToSendOtp, startForgotPassword } = useLoginModals();

  const phoneData = readStoredPhoneCredentials();
  const phoneNumber = phoneData?.number ?? "";
  const countryCode = phoneData?.dialCode ?? "+91";
  const displayNumber = `${countryCode} ${phoneNumber}`;

  const { error, loginWithPassword, isLoading } = usePasswordLogin({
    mobileNumber: phoneNumber,
    countryCode,
    onAuthenticated: onClose,
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
  };

  if (!isOpen || !phoneData) {
    return null;
  }

  return (
    <ModalView isOpen={isOpen} onClose={onClose}>
      <div className={styles.modalOverlay}>
        <div className={styles.modalContainer}>
          <div className={styles.modalHeader}>
            <h2>Password Login</h2>
            <button className={styles.closeBtn} onClick={onClose}>
              &times;
            </button>
          </div>
          <p className={styles.subText}>
            Please enter your registered phone number and password to get
            started
          </p>

          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.inputGroup}>
              <img src={phoneIcon} className={styles.icon} />
              <input
                type="tel"
                value={displayNumber}
                className={styles.input}
                readOnly
              />
            </div>

            <div className={styles.inputGroup}>
              <img src={lockIcon} className={styles.icon} />
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                placeholder="Password"
                onChange={(e) => setPassword(e.target.value)}
                className={styles.input}
              />
              <button
                type="button"
                className={styles.eyeBtn}
                onClick={() => setShowPassword((prev) => !prev)}
              >
                {showPassword ? "🙈" : "👁️"}
              </button>
            </div>
            <div className={styles.error}>{error}</div>

            <button
              type="button"
              className={styles.forgotPassword}
              onClick={startForgotPassword}
            >
              FORGOT PASSWORD?
            </button>

            <button
              type="submit"
              className={styles.loginBtn}
              onClick={() => loginWithPassword(password)}
              disabled={!password || isLoading}
            >
              LOGIN
            </button>

            <button
              type="button"
              className={styles.loginWithOtp}
              onClick={goToSendOtp}
            >
              LOGIN WITH OTP
            </button>
          </form>
        </div>
      </div>
    </ModalView>
  );
}

export default LoginWithPassword;
